// contains the parts which have aos on home page

import React from 'react';
import Banner from './Banner';
import { Link, HashRouter as Router } from 'react-router-dom';

function Parts(){
    return(
      <Router>
      <div>
      <Banner/>
      <div id="content-container">
      <div className="parts"  data-aos="flip-left">
          <div className="image">
            <img src="https://www.publicdomainpictures.net/pictures/10000/velka/old-books-11281939505Msrn.jpg#.XRNKAu8ccAg.link" alt="https://via.placeholder.com/300x300"/>
          </div>
          <h3>BOOKS</h3>
          <p>Hush! Here lies answers to your question papers.
            Contains all the books referred by teachers and used by your seniors 
          to go to the next semester successfully. Subjectwise links to books. </p>
          <div className="call-to-action"><Link to="/Books">Click Here!</Link></div>
        </div>
        <div className="parts" data-aos="flip-left">
            <div className="image">
                <img src="https://image.shutterstock.com/image-vector/unidentified-abstract-handwriting-scribble-letter-600w-638481247.jpg" alt=""/>
            </div>
            <h3>NOTES</h3>
            <p>Treasury of notes made by your geeky seniors. All thanks to them. Subjectwise links to Notes.
              Notes scaveneged will be updated, so don't worry.
            </p>
            <div className="call-to-action"><Link to="/Notes">Click Here!</Link></div>
          </div>
          <div className="parts" data-aos="flip-left"> 
              <div className="image">
                  <img src="https://www.publicdomainpictures.net/pictures/290000/velka/checklist-form.jpg#.XRNMM13zFbI.link" alt=""/>
              </div>
              <h3>SYLLABUS</h3>
              <p>The map to your academic life in the college. Contains subjectwise syllabus and 
                compiled.
              </p>
              <div className="call-to-action"><Link href="/Syllabus">Click Here!</Link></div>
            </div>
            <div className="parts"  data-aos="flip-left">
          <div className="image">
            <img src="https://www.publicdomainpictures.net/pictures/270000/velka/feedback-survey-questionnaire-e.jpg#.XRm63Kwj0gQ.link" alt="https://via.placeholder.com/300x300"/>
          </div>
          <h3>QUESTION PAPER</h3>
          <p>The staircase for you to the next semester. Contains all the question papers of the previous year which
            could be scavenged. </p>
          <div className="call-to-action"><Link to="/Question-Papers">Click Here!</Link></div>
        </div>
            <div className="parts" data-aos="zoom-in">
                <div className="image">
                    <img src="https://www.publicdomainpictures.net/pictures/190000/velka/u-buckles-clasped-to-white-chain.jpg#.XRNM3E0HLw0.link" alt=""/>
                </div>
                <h3>IMP LINKS</h3>
                <p>Here lies all the secondary or maybe the primary learning resources, links to important youtube channels and various 
                  others links.
                </p>
                <div className="call-to-action"><Link to="/Imp-Links">Click Here!</Link></div>
              </div>
              <div className="parts" data-aos="zoom-in-left">
                  <div className="image">
                      <img src="http://www.writersguru.net/wp-content/uploads/2016/11/usa-1249880_1920.jpg" alt=""/>
                  </div>
                  <h3>ABOUT</h3>
                  <p>Technologies used to make the website, had to add it just for the sake of it, all websites have about us! Lol.</p>
                  <div className="call-to-action"><Link to="/about">Click Here!</Link></div>
                </div>
          </div></div>
          </Router>
    )
}

export default Parts;